@if (categoryNametext() || gameNametext() || gameTypeText()) {
    <div class="cs-game-content-container game-content-default-version" [class]="customCategoryContainerClass()">
        @if (categoryNametext()) {
            <div class="category-name" [class]="customCategoryNameClass()" [style]="inlineStyleCategoryName()">
                {{ categoryNametext() }}
            </div>
        }
        @if (gameNametext()) {
            <div id="game-name" class="game-name" [class]="customGameNameClass()" [style]="inlineStyleGameName()">
                {{ gameNametext() }}
            </div>
        }
        @if (gameTypeText()) {
            <div class="game-type" [class]="customGameTypeClass()" [style]="inlineStyleGameType()">
                {{ gameTypeText() }}
            </div>
        }
    </div>
}
